import { CommonProductModel, Feature, PromoModel } from '@common/models';

export enum ApplianceSource {
    CUSTOMER = 'CUSTOMER',
    IN_STORE = 'In-Store',
    PROGRAM = 'Program',
}

export enum ApplianceType {
    COOKTOP = 'COOKTOP',
    DISHWASHER = 'DISHWASHER',
    FAUCET = 'FAUCET',
    RANGE = 'RANGE',
    REFRIGERATOR = 'REFRIGERATOR',
    SINK = 'SINK',
    SINK_LABOR = 'SINK_LABOR',
}

export const AppliancesAllowedOnShapes = [
    ApplianceType.COOKTOP,
    ApplianceType.DISHWASHER,
    ApplianceType.FAUCET,
    ApplianceType.RANGE,
    ApplianceType.SINK,
    ApplianceType.SINK_LABOR,
];

export const AppliancesAllowedOutsideShapes = [
    ApplianceType.DISHWASHER,
    ApplianceType.RANGE,
    ApplianceType.REFRIGERATOR,
];

/**
 * These are the "iron types" (an old indicator for the type of sink cutout required based on the type of material
 * the sink was made of - originally cast iron or "other" for stainless steel, then expanded).
 * These definitions are from the stored procedure `usp_eeapi_CAT_Product_GetSinkLaborProductID`
 * It's not really important for us to know these, we don't base anything on them, but it's here for documentation purposes
 */
export enum IRON_TYPES {
    POLISHED_OTHER = -1,
    POLISHED_CAST_IRON = 0,
    POLISHED_OTHER_ALT = 1,
    POLISHED_APRON = 2,
    UNPOLISHED = 3,
    POLISHED_SOLIDSURFACE = 4,
    POLISHED_VANITY = 5,
}

export interface ApplianceModel extends CommonProductModel {
    applianceType: ApplianceType;
    brand: string;
    beautyShotImageUrl: string | null;
    depth: number | null; // actual depth of the appliance in inches
    discountPercentage: number | null;
    features: Feature[];
    height: number;
    id: number;
    imageUrl: string | null;
    ironType?: IRON_TYPES;
    length: number; // actual length of the appliance (x-dimension when placing on design) in inches
    model?: string;
    modelNumber?: string;
    priceWithoutDiscount: number;
    productSource: ApplianceSource;
    promos: PromoModel[];
    rank: number;
    type: string;
    uuid: string;
    width: number; // actual width of the appliance (y-dimension when placing on design) in inches
}
